import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  background-color: #fff;
  width: 100%;
  height: 628px;
  align-items: center;
  border-radius: 12px;
  padding: 1em;
  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

const ImageBanner = styled.div`
  width: 100%;
  height: 460px;
  filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.1));
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 4.4em;
  margin-bottom: 1em;
  text-align: left;
  padding-top: 1.5em;
  font-style: normal;
  font-weight: bold;  
  font-size: 16px;
  line-height: 24px;
  color: #000000;
`;

const ButtonHref = styled.a`
  display: flex;
  justify-content: center;
  padding: 12px 16px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
`;

const LinkWithImage = (props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ImageBanner>
        <img src={props.image} alt="0" />
      </ImageBanner>
      <Title>{props.title}</Title>
      <div>
        <ButtonHref
          type="button"
          className="btn btn-outline-warning"
          href={props.file}
          target="blank"
        >
          {t("download")}
        </ButtonHref>
      </div>
    </Container>
  );
};

export default LinkWithImage;
